import React from "react";
import styled from "styled-components";
import HeaderLogo from "./HeaderLogo";
import IconBtn from "../button/IconBtn";
// import { useCookies } from 'react-cookie';

import {isMobileOnly} from 'react-device-detect';

const HeaderBlock = styled.header`
    position:fixed;
    content: '';
    display: ${isMobileOnly?'flex':'block'};
    ${isMobileOnly&&`justify-content:space-between; align-items:center;`};
    clear: both;
    z-index: 50;
    padding: ${isMobileOnly?"30px 20px":"30px 52px 36px"};
    background-color: ${props => props.bgColor || '#ffc742'};
    // border-bottom: 1px solid #ececec;
`;

const CloseBlock = styled.div`
    ${!isMobileOnly&&`
      position: absolute;
      top: 38px;
      right: 55px;    
    `};
    z-index: 1;
`;

const TitleBlock = styled.h2`
    ${isMobileOnly ?`
      flex: 1;
      text-align: center;
    `: `
      position: absolute;
      top: 50%;
      left: 50%;
      -webkit-transform: translate(-50%,-50%);
      -ms-transform: translate(-50%,-50%);
      transform: translate(-50%,-50%);
      text-align: center;
      width: 100%;
      `
    };
    
    font-size: ${isMobileOnly?'28px':'40px'};
    font-weight: 700;
    
`;

const NumberSpanBlock = styled.span`
    display: inline-block;
    margin-right: 20px;
    font-size: 15px;
    font-weight: 400;
    vertical-align: 5px;
`;

const HeaderEs = ({ rqst_id, name, onCloseClick, bgColor, isLogoShow = false }) => {
    return (
        <HeaderBlock bgColor={bgColor}>
            <HeaderLogo text="어디가구" link="/"
                isLogoShow={isLogoShow} />
            <TitleBlock>
                {name}
            </TitleBlock>
            <CloseBlock>
                <NumberSpanBlock style={{ display: rqst_id === null ? 'none' : 'inline-block' }}>
                    NO. <span>{rqst_id}</span>
                </NumberSpanBlock>
                <IconBtn width='22px' height='22px'
                    onClick={onCloseClick}
                    img={'/assets/images/icon/popup_heade_close-icon.png'} />
            </CloseBlock>
        </HeaderBlock>
    );
};

export default HeaderEs;
